import Vue from 'vue'
import VueRouter from 'vue-router'
import { authGuard } from '@/auth/authGuard'

import LostPropeties from '@/views/lost-properties/LostProperties.vue'
import LostPropetiesDetails from '@/views/lost-properties/LostPropertiesDetails.vue'

import Inquiries from '@/views/inquiries/Inquiries.vue'
import InquiriesDetails from '@/views/inquiries/InquiriesDetails.vue'

import MasterdataCategories from '@/views/masterdata/categories/MasterdataCategories.vue'
import MasterdataSubCategories from '@/views/masterdata/subcategories/MasterdataSubCategories.vue'
import MasterdataEmailTemplates from '@/views/masterdata/email-templates/MasterdataEmailTemplates.vue'

import BusinessIntelligenceFoundInquiriesResolved from '@/views/business-intelligence/found-inquiries-resolved/BusinessIntelligenceFoundInquiriesResolved.vue'

Vue.use(VueRouter)

const APP_TITLE = 'Hittegodsportalen'

const routes = [
  {
    path: '/:owner/inquiries',
    name: 'inquiries',
    beforeEnter: authGuard,
    component: Inquiries,
    meta: {
      title: 'Förfrågningar',
    },
  },
  {
    path: '/:owner/inquiries/:uuid',
    name: 'inquiries-details',
    beforeEnter: authGuard,
    component: InquiriesDetails,
    meta: {
      title: 'Förfrågning detaljer',
    },
  },
  {
    path: '/:owner/lost-properties',
    name: 'lost-properties',
    beforeEnter: authGuard,
    component: LostPropeties,
    meta: {
      title: 'Upphittade föremål',
    },
  },
  {
    path: '/:owner/lost-properties/:uuid',
    name: 'lost-properties-details',
    component: LostPropetiesDetails,
    beforeEnter: authGuard,
    meta: {
      title: 'Upphittat detaljer',
    },
  },
  {
    path: '/:owner/business-intelligence/found-inquiries-resolved',
    name: 'found-inquiries-resolved',
    component: BusinessIntelligenceFoundInquiriesResolved,
    beforeEnter: authGuard,
    meta: {
      title: 'BI - Upphittade, förfrågningar och utlämnat',
    },
  },
  {
    path: '/:owner/masterdata/categories',
    name: 'masterdata-categories',
    component: MasterdataCategories,
    beforeEnter: authGuard,
    meta: {
      title: 'Stamdata - Kategorier',
    },
  },
  {
    path: '/:owner/masterdata/subcategories',
    name: 'masterdata-subcategories',
    component: MasterdataSubCategories,
    beforeEnter: authGuard,
    meta: {
      title: 'Stamdata - Underkategorier',
    },
  },
  {
    path: '/:owner/masterdata/email-templates',
    name: 'masterdata-email-templates',
    component: MasterdataEmailTemplates,
    beforeEnter: authGuard,
    meta: {
      title: 'Stamdata - Email mallar',
    },
  },
  {
    path: '*',
    name: 'root',
    beforeEnter: authGuard,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  document.title = `${APP_TITLE} - ${to.meta.title}`

  next()
})

export default router
